/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OutgoingPaymentState } from './outgoingPaymentState.model';
import { BarterState } from './barterState.model';
import { PaymentType } from './paymentType.model';
import { PaymentMethodCode } from './paymentMethodCode.model';


export interface OutgoingPayment { 
    amount: number;
    barterId?: number;
    barterNumber?: string;
    barterState?: BarterState;
    contractId?: number;
    contractOfficialNumber?: string;
    contractState?: string;
    generatingDate?: string;
    id?: number;
    isRecipientPaymentSubjectRepresentative?: boolean;
    note?: string;
    orderName?: string;
    paymentStatusCheck?: string;
    paymentType?: PaymentType;
    paymentYear: number;
    payoutDate?: string;
    recipientAccount?: string;
    recipientAddress?: string;
    recipientAddressCity?: string;
    recipientAddressCityPart?: string;
    recipientAddressHouseNumber?: string;
    recipientAddressPartOfVillage?: string;
    recipientAddressState?: string;
    recipientAddressStreet?: string;
    recipientAddressZipcode?: string;
    recipientFirstName?: string;
    recipientIban?: string;
    recipientIdentificationNumber?: string;
    recipientName?: string;
    recipientOriginalSubjectId: number;
    recipientPaymentMethod?: PaymentMethodCode;
    recipientPaymentSubjectId: number;
    recipientPersonalNumber?: string;
    recipientSubjectId: number;
    recipientSurname?: string;
    recipientSwift?: string;
    recipientWithdrawPostage: boolean;
    returnedDate?: string;
    sendDate?: string;
    senderSubjectId: number;
    specificSymbol?: string;
    state: OutgoingPaymentState;
    stateOrder?: number;
    variableSymbol?: string;
}
export namespace OutgoingPayment {
}


